<template>
  <div class="knowledge-4">
    <div class="knowledge-tip"> {{$t('headerMsg.financialDetails')}}</div>
    <el-form :model="formData" :rules="rules" label-position="top" ref="ruleForm">
      <el-form-item :label="$t('Knowledge.DT_Work_Experience')" prop="DT_Work_Experience">
        <div class="radio-list-h5">
          <div class="radio-h5 radio-h5-no"><el-radio v-model="formData.experience" label="Y">{{$t('Knowledge.DT_Work_Experience_select.txt1')}}</el-radio></div>
          <!-- 小屏幕YES选择项提上来 -->
          <el-radio-group v-if="screenWidth<=768" v-model="formData.DT_Work_Experience" v-show="formData.experience == 'Y'">
            <el-radio label="2" class="new-radio-01 radio-son">{{$t('Knowledge.DT_Work_Experience_select.subTxt1')}}</el-radio>
            <el-radio label="1" class="new-radio-02 radio-son">{{$t('Knowledge.DT_Work_Experience_select.subTxt2')}}</el-radio>
          </el-radio-group>
          <div class="radio-h5"><el-radio v-model="formData.experience" label="0">{{$t('Knowledge.DT_Work_Experience_select.txt2')}}</el-radio></div>
        </div>
        <!-- 大屏幕YES选择项在下 -->
        <el-radio-group v-if="screenWidth>768" v-model="formData.DT_Work_Experience" v-show="formData.experience == 'Y'">
            <el-radio label="2" class="new-radio-01 radio-son">{{$t('Knowledge.DT_Work_Experience_select.subTxt1')}}</el-radio>
            <el-radio label="1" class="new-radio-02 radio-son">{{$t('Knowledge.DT_Work_Experience_select.subTxt2')}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('Knowledge.DT_Qualification')" prop="DT_Qualification">
        <div class="radio-list-h5">
          <div class="radio-h5 radio-h5-no"><el-radio v-model="formData.qualification" label="Y">{{$t('Knowledge.DT_Qualification_select.txt1')}}</el-radio></div>
          <!-- 小屏幕YES选择项提上来 -->
          <el-radio-group v-if="screenWidth<=768" v-model="formData.DT_Qualification" v-show="formData.qualification == 'Y'">
            <el-radio label="2" class="new-radio-01 radio-son">{{$t('Knowledge.DT_Qualification_select.subTxt1')}}</el-radio>
            <el-radio label="1" class="new-radio-02 radio-son">{{$t('Knowledge.DT_Qualification_select.subTxt2')}}</el-radio>
          </el-radio-group>
          <div class="radio-h5"><el-radio v-model="formData.qualification" label="0">{{$t('Knowledge.DT_Qualification_select.txt2')}}</el-radio></div>
        </div>
        <!-- 大屏幕YES选择项在下 -->
        <el-radio-group v-if="screenWidth>768" v-model="formData.DT_Qualification" v-show="formData.qualification == 'Y'">
          <el-radio label="2" class="new-radio-01 radio-son">{{$t('Knowledge.DT_Qualification_select.subTxt1')}}</el-radio>
          <el-radio label="1" class="new-radio-02 radio-son">{{$t('Knowledge.DT_Qualification_select.subTxt2')}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('Knowledge.K_Sell_Position')" prop="K_Sell_Position">
        <el-radio-group v-model="formData.K_Sell_Position">
          <div class="radio-list-h5">
            <div class="radio-h5 radio-h5-no"><el-radio label="0">{{$t('Knowledge.K_Sell_Position_select.0')}}</el-radio></div>
            <div class="radio-h5"><el-radio label="1">{{$t('Knowledge.K_Sell_Position_select.1')}}</el-radio></div>
          </div>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('Knowledge.Closing_Order')" prop="Closing_Order">
        <el-radio-group v-model="formData.Closing_Order">
          <div class="radio-list-h5">
            <div class="radio-h5 radio-h5-no"><el-radio label="0">{{$t('Knowledge.Closing_Order_select.0')}}</el-radio></div>
            <div class="radio-h5"><el-radio label="1">{{$t('Knowledge.Closing_Order_select.1')}}</el-radio></div>
          </div>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('Knowledge.K_Profit_Change')" prop="K_Profit_Change">
        <el-radio-group v-model="formData.K_Profit_Change">
          <div class="radio-list-h5">
            <div class="radio-h5 radio-h5-no"><el-radio label="0">{{$t('Knowledge.K_Profit_Change_select.0')}}</el-radio></div>
            <div class="radio-h5"><el-radio label="1">{{$t('Knowledge.K_Profit_Change_select.1')}}</el-radio></div>
          </div>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('Knowledge.K_Margin')" prop="K_Margin">
        <el-radio-group v-model="formData.K_Margin">
          <div class="radio-list-h5 s-radio-list-h5">
            <div class="radio-h5 radio-h5-no"><el-radio label="0">{{$t('Knowledge.K_Margin_select.0')}}</el-radio></div>
            <div class="radio-h5"><el-radio label="1">{{$t('Knowledge.K_Margin_select.1')}}</el-radio></div>
            <div class="radio-h5"><el-radio label="2">{{$t('Knowledge.K_Margin_select.2')}}</el-radio></div>
          </div>
        </el-radio-group>
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    mixins: [
      require("@/assets/mixin/base.js").base('Knowledge')
    ],
    props: ['Lead', 'middle_dataware', 'screenWidth'],
    data() {
      const v_DT_Work_Experience = (rule, value, callback) => {
        if (this.formData.experience == 'Y') {
          if (!value) callback(new Error(this.$t("customErrMsg.fieldIsRequired.DT_Work_Experience")))
          else callback();
        } else if (!this.formData.experience) {
          callback(new Error(this.$t("customErrMsg.fieldIsRequired.DT_Work_Experience")))
        }
        callback()
      }
      const v_DT_Qualification = (rule, value, callback) => {
        if (this.formData.qualification == 'Y') {
          if (!value) callback(new Error(this.$t("customErrMsg.fieldIsRequired.DT_Qualification")))
          else callback();
        } else if (!this.formData.qualification) {
          callback(new Error(this.$t("customErrMsg.fieldIsRequired.DT_Qualification")))
        }
        callback()
      }
      return {
        rules: {
          DT_Work_Experience: [{
            required: true,
            validator: v_DT_Work_Experience,
            trigger: 'change'
          }],
          DT_Qualification: [{
            required: true,
            validator: v_DT_Qualification,
            trigger: 'change'
          }],
          K_Sell_Position: [{
            required: true,
            message:'Above is required', 
            trigger: 'change'
          }],
          Closing_Order: [{
            required: true,
            message:'Above is required',
            trigger: 'change'
          }],
          K_Profit_Change: [{
            required: true,
            message:'Above is required',
            trigger: 'change'
          }],
          K_Margin: [{
            required: true,
            message:'Above is required',
            trigger: 'change'
          }]
        }
      };
    },
    mounted() {
      _g.trackStepPage(5);
    },
    methods: {
      getPageFormData(cb) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            //更新salesforce步骤
            Util.editSalesforce(this.middle_dataware, 5);
            this.calculateScore();
            return cb(true)
          } else {
            // return cb(true);
            return cb(false)
          }
        });
      },
      calculateScore() {
        var arr=[
          {name:"Futures_Options",scores:{'0':6,'1':4,'2':2,'3':0}},
          {name:"CFDs_Spread_Bets",scores:{'0':8,'1':6,'2':4,'3':0}},
          {name:"Derivative_Trade_over2",scores:{'0':0,'1':2}},
          {name:"Derivative_Trade_over40",scores:{'0':0,'1':2}},
          {name:"DT_Work_Experience",scores:{'0':-5,'1':2,'2':3}},
          {name:"DT_Qualification",scores:{'0':-5,'1':2,'2':3}},
          {name:"K_Sell_Position",scores:{'0':1,'1':0}},
          {name:"Closing_Order",scores:{'0':1,'1':0}},
          {name:"K_Profit_Change",scores:{'0':1,'1':0}},
          {name:"K_Margin",scores:{'0':1,'1':0,'2':0}},
          {name:"Afford_To_Lose",scores:{'Y':0,'N':-34}},
          {name:"Open_Trading_Account",scores:{'0':0,'1':0,'2':0}},
          {name:"Average_Annual_Investment",scores:{'0':-20,'1':1,'2':2,'3':3,'4':4}},
          {name:"Average_Leverage_Level",scores:{'0':-10,'1':2,'2':3,'3':4,'4':5,'5':6}}
        ]
        let scores = 0;
        arr.forEach(item=>{
          console.log('item', item);
          console.log('scores', parseFloat(item.scores[this.formData[item.name]]));
          scores += parseFloat(item.scores[this.formData[item.name]]) || 0
        })
        this.formData.APT_Point =  scores;
        if(scores < 8){
          this.$store.commit("SAVEMODALSTATUS", true)
        }
        console.log('total', scores);
      }
    },
    computed:{
      ...mapState(["knowledgeLabel"])
    },
    watch: {
      'formData.experience'(newVal, oldVal) {
        if (newVal == '0') this.formData.DT_Work_Experience = newVal
        else this.formData.DT_Work_Experience = ''
      },
      'formData.qualification'(newVal, oldVal) {
        if (newVal == '0') this.formData.DT_Qualification = newVal
        else this.formData.DT_Qualification = ''
      }
    }
  }

</script>

<style lang="scss">
  .el-form-item--small .el-form-item__label,.el-form-item--small .el-form-item__content {
    line-height: normal;  
  }

  .knowledge-4 {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    .knowledge-tip {
      font-size: 15px;
      // color: #4d5053;
      padding: 10px 0;
      width: 100%;
    }
    .el-form-item__label{
      color: black;
    }
    .new-radio-01,
    .new-radio-02 {
      display: block;
      border-left: 2px solid #f2672a;
      // padding: 10px 20px;
      padding: 10px 0 0 30px;
      // font-family: Roboto;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.3px;
      color: #323232;
      margin: 0;
      margin-left: 6px !important;
    }
    // .radio-list-h5{
    //   display: flex;
    // }
    // .radio-h5{
    //   margin-left: 30px;
    //   min-width: 100px;
    // }
    // .radio-h5-no{
    //   margin-left: 0px;
    // }
    @media (max-width: 768px){
      // .radio-list-h5{
        // display: flex;
        // flex-wrap:wrap;
      // }
      // .s-radio-list-h5{
      //   display: block;
      // }
      // .radio-h5{
      //   width: 30%;
      // }
      // .radio-h5-no{
      //   margin-left: 30px;
      // }
      .radio-son{
        text-overflow: ellipsis !important;
        white-space: normal !important;
      }
      .radio-h5 {
        margin-top: 16px;
        margin-bottom: 0;
      }
      .radio-h5:first-child {
        margin-top: 0;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/view/steps/knowledge.vue